import React from "react";
import Typography from "@material-ui/core/Typography";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { MedsafeVerboseLogoUrl } from "../assets/images";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      alignItems: "center",
      display: "flex",
      height: "calc(100vh - 80px)",
      justifyContent: "center",
      width: "100%",
      flexDirection: "column"
    },
    logo: {
      alignItems: "center",
      display: "flex",
      height: "150px",
      justifyContent: "center",
      width: "100%"
    }
  });

type State = {};

type Props = {
  classes?: any;
};

class Dashboard extends React.Component<Props, State> {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.logo}>
          <img 
            alt="medsafe"
            height={62} 
            src={MedsafeVerboseLogoUrl}
            />
        </div>
        <Typography align="center" variant="h3">
          Welcome to Medicines Control Online System
        </Typography>

        <Typography align="center" variant="h4">
          Select an activity from the navigation menu to get started
        </Typography>
      </div>
    );
  }
}

export default withStyles(styles)(Dashboard);
